/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Fab,
  Badge,
  Popover,
  IconButton,
  Tooltip,
  Grid,
  Typography,
} from '@mui/material';
import {
  Close,
  Forum,
  Launch,
  QuestionAnswer,
} from '@mui/icons-material';
import { Chat } from 'stream-chat-react';
import { primary } from '../../utils/brandColors';
import { WorkspaceController } from '../../stream/context/WorkspaceController';
import { Sidebar } from '../../stream/components/Sidebar/Sidebar';
import { ChannelContainer } from '../../stream/components/ChannelContainer/ChannelContainer';

const PageBody = ({
  children,
  disablePadding,
  navigate,
  unreadCount,
  chatClient,
  width,
}) => {
  const [showChat, setShowChat] = React.useState(false);
  const [chatAnchorEl, setChatAnchorEl] = React.useState(null);

  const handleGoToChatPage = () => {
    setChatAnchorEl(null);
    setShowChat(false);
    navigate('/chat')
  };
  const handleClose = () => {
    setChatAnchorEl(null);
    setShowChat(false);
  };

  return (
    <Box
      sx={{
        p: disablePadding
          ? '0'
          : '1rem',
        width: width || '100%',
      }}
    >
      {children}
      {
      chatClient && (
        <Fab
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
          }}
          aria-label="Questri Chat"
          color="primary"
          onClick={(e) => { setChatAnchorEl(e.currentTarget); setShowChat(true); }}
        >
          <Badge badgeContent={unreadCount} color="error">
            <Forum />
          </Badge>
        </Fab>
      )
    }
      <Popover
        open={showChat}
        anchorEl={chatAnchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Grid
          container
          sx={{
            width: {
              xs: 360,
              sm: 500,
            },
          }}
        >
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: primary[500],
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  backgroundColor: primary[500],
                  ml: 1,
                }}
              >
                <QuestionAnswer
                  sx={{
                    color: 'white',
                    mr: 1,
                  }}
                />
                <Typography variant="h6" sx={{ color: 'white' }}>
                  Questri Chat
                </Typography>
              </Box>

              <Box>
                <Tooltip title="Go to chat page for more options">
                  <IconButton onClick={handleGoToChatPage}>
                    <Launch sx={{ color: 'white' }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Close chat">
                  <IconButton onClick={handleClose}>
                    <Close sx={{ color: 'white' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

          </Grid>
          <Grid item xs={12} sx={{ height: 600 }}>
            <Chat
              client={chatClient}
              defaultLanguage="en"
              theme="team light"
            >
              <Box className="app__wrapper str-chat" sx={{ height: 600 }}>
                <WorkspaceController>
                  <Sidebar popout />
                  <ChannelContainer popout />
                </WorkspaceController>
              </Box>
            </Chat>
          </Grid>
        </Grid>
      </Popover>
    </Box>
  );
}

PageBody.propTypes = {
  children: PropTypes.any,
  disablePadding: PropTypes.bool,
  navigate: PropTypes.func,
  chatClient: PropTypes.any,
  unreadCount: PropTypes.number,
  width: PropTypes.string,
};

PageBody.defaultProps = {
  children: null,
  disablePadding: false,
  navigate: () => {},
  chatClient: null,
  unreadCount: 0,
  width: null,
};

export default PageBody;
